import { barnToolsApi } from './base';
import { IOrganization, IOrganizationCollection } from './types';

export const organizationApi = barnToolsApi
  .enhanceEndpoints({ addTagTypes: ['orgs', 'gateways'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOrg: builder.query<{ Organization: IOrganization }, string>({
        query: (id) => `organizations/${id}`,
        providesTags: (result) => {
          if (result) {
            return [{ type: 'orgs', id: result.Organization.id }];
          } else {
            return ['orgs'];
          }
        },
      }),
      getOrgs: builder.query<IOrganizationCollection, void>({
        query: () => `organizations/`,
        providesTags: (result) =>
          result
            ? [
                ...result.Organizations.map(({ id }) => ({
                  type: 'orgs' as const,
                  id,
                })),
                'orgs',
              ]
            : ['orgs'],
      }),
      createOrg: builder.mutation({
        query: (name) => {
          return {
            url: `organizations/`,
            method: 'POST',
            body: { name: name },
          };
        },
        invalidatesTags: ['orgs'],
      }),
      updateOrg: builder.mutation({
        query: (args: { id: string; name: string }) => {
          return {
            url: `organizations/${args.id}`,
            method: 'PUT',
            body: { name: args.name },
          };
        },
        invalidatesTags: ['orgs'],
      }),
      deleteOrg: builder.mutation({
        query: (id) => {
          return {
            url: `organizations/${id}`,
            method: 'DELETE',
          };
        },
        invalidatesTags: ['orgs'],
      }),
      assignGateway: builder.mutation({
        query: (args: {
          orgId: string;
          gatewaySerial: string;
          gatewayName: string;
        }) => {
          return {
            url: `organizations/${args.orgId}/gateways`,
            method: 'POST',
            body: { serialNumber: args.gatewaySerial, name: args.gatewayName },
          };
        },
        invalidatesTags: ['gateways'],
      }),
    }),
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetOrgQuery,
  useGetOrgsQuery,
  useCreateOrgMutation,
  useUpdateOrgMutation,
  useDeleteOrgMutation,
  useAssignGatewayMutation,
} = organizationApi;
